module.exports = __webpack_public_path__ + "img/like.c63f30e4.svg";